import type { RefObject } from 'react'
import { Tooltip, type TooltipRefProps } from 'react-tooltip'

import styles from './custom-tooltip.module.scss'

type TCustomTooltip = {
    children: React.ReactNode
    isFirst?: boolean
    tooltipRef: RefObject<null | TooltipRefProps>
}

export const CustomTooltip = ({
    isFirst,
    tooltipRef,
    children,
}: TCustomTooltip): React.ReactNode => {
    return (
        <Tooltip
            ref={tooltipRef}
            clickable
            className={`${styles['custom-tooltip']} ${isFirst && styles['custom-tooltip--translate-y-16']}`}
            classNameArrow={styles['custom-tooltip__arrow']}
            closeEvents={{ click: true }}
            place='bottom-start'
        >
            {children}
        </Tooltip>
    )
}
